const openers = document.querySelectorAll(".responsibility__opener");

if (openers) {
  const className = "responsibility__group--opened";

  const changeClassNames = (currentAccordion, i) => {
    currentAccordion.classList.toggle(className);
    openers.forEach((opener, index) => {
      if (i !== index) opener.parentElement.classList.remove(className);
    });
  };

  openers.forEach((opener, i) => {
    opener.addEventListener("click", () => {
      changeClassNames(opener.parentElement, i);
    });
  });
}
